import { fb } from '../plugins/firebase'
import { momento } from '../plugins/moment'
import { limpiar } from '../mixins/limpiar'

export default {
  namespaced: true,
  state: {
    colecciones: []
  },
  mutations: {
    pushColeccion(state, p) {
      state.colecciones.push(p)
    },
    setColecciones(state, p) {
      state.colecciones = p
    },
    remover(state, p) {
      let index = state.colecciones.findIndex(sel => sel.id === p)
      state.colecciones.splice(index, 1)
    },
    update (state, p) {
      let index = state.colecciones.findIndex(sel => sel.id === p.id)
      state.colecciones[index] = p
    }
  },
  actions: {
    setCol (ctx, p) {
      return new Promise ((resolve, reject) => {
        p.creado = momento().format()
        fb.collection('colecciones').add(p)
        .then(ans => {
          p.id = ans.id
          ctx.commit('pushColeccion', p)
          resolve(p)
        })
        .catch(e => {
          reject(false)
          console.error(e)
        })
      })
    },
    getCols (ctx) {
      return new Promise ((resolve, reject) => {
        let all = []
        fb.collection('colecciones').get()
        .then(results => {
          results.forEach(doc => {
            let col = doc.data()
            col.id = doc.id
            if (col.ubicacion.length > 1) {
              let reorder = col.ubicacion.sort((a, b) => {
                const aL = limpiar(a)
                const bL = limpiar(b)
                if (aL < bL)
                  return -1 
                if (aL > bL)
                  return 1
                return 0
              })
              col.ubicacion = reorder
            }
            all.push(col)
          })
          ctx.commit('setColecciones', all)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    remover (ctx, p) {
      return new Promise ((resolve, reject) => {
        fb.collection('colecciones').doc(p).delete()
        .then(() => {
          ctx.commit('remover', p)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    },
    update (ctx, p) {
      return new Promise ((resolve, reject) => {
        if (p.ubicacion.length > 1) {
          let reorder = p.ubicacion.sort((a, b) => {
            const aL = limpiar(a)
            const bL = limpiar(b)
            if (aL < bL)
              return -1 
            if (aL > bL)
              return 1
            return 0
          })
          p.ubicacion = reorder
        }
        fb.collection('colecciones').doc(p.id).update(p)
        .then(() => {
          ctx.commit('update', p)
          resolve()
        })
        .catch(e => {
          console.error(e)
          reject()
        })
      })
    }
  },
  getters: {
    getAll (state) {
      return state.colecciones.sort((a, b) => {
        const aL = limpiar(a.text)
        const bL = limpiar(b.text)
        if (aL < bL)
          return -1 
        if (aL > bL)
          return 1
        return 0
      })
    },
    getById: (state) => (p) => {
      return state.colecciones.find(sel => sel.id === p)
    }
  }
}

